import settings from '@/settings/settings.json'
import SentrySingleton from '@/singletons/sentry-singleton';

export default class NameConverterService {
    convertToFontMeshCharacters(text: any) {
        try {
            text = text.replace(/-/g, "ー"); // use long minus characters, not short minus
            return this.convertSpecialCharacters(this.convertTo1ByteCharacters(this.replaceNotSupportedMeshCharacters(text)), false).toUpperCase();
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return text
        }
    }

    convertToHTMLCharacters(text: any) {
        try {
            return this.convertSpecialCharacters(this.convertTo1ByteCharacters(text), true).toUpperCase();
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return text
        }
    }

    convertTo2ByteCharacters(text: any) {
        let swappedMap = {};
        Object.keys(japMap).forEach(key => {
            swappedMap[japMap[key]] = key;
        });
        var reg = this.createRegex(swappedMap);
        return text.replace(reg, function (match) {
            return swappedMap[match];
        });
    }

    private convertTo1ByteCharacters(text: any) {
        var reg = this.createRegex(japMap);
        return text.replace(reg, function (match) {
            return japMap[match];
        });
    }

    private createRegex(map: any) {
        return new RegExp('(' + Object.keys(map).join('|').replace(/-/g, "\\-").replace(/\./g, "\\.") + ')', 'g');
    }

    private convertSpecialCharacters(text: any, useHTMLCharacter = false) {
        var newText = text;
        for (let i = 0; i < settings.specialCharacters.length; i++) {
            var reg = new RegExp(settings.specialCharacters[i].index, "g");
            var c = useHTMLCharacter ? settings.specialCharacters[i].html : settings.specialCharacters[i].value;
            newText = newText.replace(reg, c);
        }
        return newText;
    }

    private replaceNotSupportedMeshCharacters(text: any) {
        let newText = "";
        [...text].forEach(c => {
            if (settings.allowedChars.includes(c)) {
                newText += c;
            } else {
                newText += "";
                console.error("Unknown character for font mesh: '" + c + "'");
            }
        });
        return newText;
    }

}

const japMap = {
    "ａ": "a",
    "ｂ": "b",
    "ｃ": "c",
    "ｄ": "d",
    "ｅ": "e",
    "ｆ": "f",
    "ｇ": "g",
    "ｈ": "h",
    "ｉ": "i",
    "ｊ": "j",
    "ｋ": "k",
    "ｌ": "l",
    "ｍ": "m",
    "ｎ": "n",
    "ｏ": "o",
    "ｐ": "p",
    "ｑ": "q",
    "ｒ": "r",
    "ｓ": "s",
    "ｔ": "t",
    "ｕ": "u",
    "ｖ": "v",
    "ｗ": "w",
    "ｘ": "x",
    "ｙ": "y",
    "ｚ": "z",
    "Ａ": "A",
    "Ｂ": "B",
    "Ｃ": "C",
    "Ｄ": "D",
    "Ｅ": "E",
    "Ｆ": "F",
    "Ｇ": "G",
    "Ｈ": "H",
    "Ｉ": "I",
    "Ｊ": "J",
    "Ｋ": "K",
    "Ｌ": "L",
    "Ｍ": "M",
    "Ｎ": "N",
    "Ｏ": "O",
    "Ｐ": "P",
    "Ｑ": "Q",
    "Ｒ": "R",
    "Ｓ": "S",
    "Ｔ": "T",
    "Ｕ": "U",
    "Ｖ": "V",
    "Ｗ": "W",
    "Ｘ": "X",
    "Ｙ": "Y",
    "Ｚ": "Z",
    "１": "1",
    "２": "2",
    "３": "3",
    "４": "4",
    "５": "5",
    "６": "6",
    "７": "7",
    "８": "8",
    "９": "9",
    "０": "0",
    // "３": "3",
    // "４": "4",
    // "５": "5",
    // "６": "6",
    // "７": "7",
    // "８": "8",
    // "９": "9",
    "・": "･",
    "　": " ",
    "−": "-",
    "．": ".",
}